/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TrainingPlanDomain } from './trainingPlanDomain';


export interface UserTrainingPlanCourseTypesInnerCoursesInner { 
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    archived?: boolean;
    /**
     * 
     */
    refcode?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    descr?: string;
    /**
     * 
     */
    autoAdd?: boolean;
    /**
     * 
     */
    canAlterHours?: boolean;
    /**
     * 
     */
    hasHours?: boolean;
    /**
     * 
     */
    exemptionHoursType?: UserTrainingPlanCourseTypesInnerCoursesInner.ExemptionHoursTypeEnum;
    /**
     * 
     */
    hoursRequired?: number;
    /**
     * 
     */
    domains?: Array<TrainingPlanDomain>;
}
export namespace UserTrainingPlanCourseTypesInnerCoursesInner {
    export type ExemptionHoursTypeEnum = 'day' | 'hour';
    export const ExemptionHoursTypeEnum = {
        Day: 'day' as ExemptionHoursTypeEnum,
        Hour: 'hour' as ExemptionHoursTypeEnum
    };
}


